import React from 'react'
// import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { darkTheme } from '../Themes';
import { Facebook, Github, Twitter, Linkedin } from './AllSvgs'
import {motion} from 'framer-motion'

const Icons = styled.div`
    display: flex;
    flex-direction: column;
    align-items:center;

    position: fixed;
    bottom:0;
    left: 2rem;

    z-index:3;

    &>*:not(:last-child){
        margin: 0.5rem 0;
    }
    @media (max-height: 620px) {
        left: 0.8rem;
      }
    @media (max-width: 620px) {
        left: 0.8rem;
      }
`;

const Line = styled(motion.span)`
width: 2px;
height: 8rem;
background-color: ${props=>props.color === 'dark' ? darkTheme.text : darkTheme.body };
    @media (max-height: 620px) {
    height:2rem!Important;
    }
    @media (max-height: 450px) {
    height:1rem!Important;
    }
    @media (max-width: 1240px) {
      height:6rem!important;
    }
    @media (max-width: 620px) {
        height:2rem!important;
    }
`
function SocialIcons(props) {
  return (
    <Icons>
        <motion.div
        initial ={{transform:"scale(0)"}}
        animate={{scale:[0,1,1.5,1]}}
        transition={{type:'spring', duration:1, delay:1}}
        >
            <a style={{color:'inherit'}} target="_blank" rel="noreferrer" href="https://github.com/777ahesh" >
                <Github width={25} height={25} fill={props.theme ==="dark" ? darkTheme.text : darkTheme.body}/>
            </a>
        </motion.div>
        <motion.div
        initial ={{transform:"scale(0)"}}
        animate={{scale:[0,1,1.5,1]}}
        transition={{type:'spring', duration:1, delay:1.2}}
        >
            <a style={{color:'inherit'}} target="_blank" rel="noreferrer" href="https://twitter.com/777aheshg">
                <Twitter width={25} height={25} fill={props.theme ==="dark" ? darkTheme.text : darkTheme.body}/>
            </a>
        </motion.div>
        <motion.div
        initial ={{transform:"scale(0)"}}
        animate={{scale:[0,1,1.5,1]}}
        transition={{type:'spring', duration:1, delay:1.4}}
        >
            <a style={{color:'inherit'}} target="_blank" rel="noreferrer" href="https://facebook.com/777ahesh">
                <Facebook width={25} height={25} fill={props.theme ==="dark" ? darkTheme.text : darkTheme.body}/>
            </a>
        </motion.div>
        <motion.div
        initial ={{transform:"scale(0)"}}
        animate={{scale:[0,1,1.5,1]}}
        transition={{type:'spring', duration:1, delay:1.6}}
        >
            <a style={{color:'inherit'}} target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/777ahesh/">
                <Linkedin width={25} height={25} fill={props.theme ==="dark" ? darkTheme.text : darkTheme.body}/>
            </a>
        </motion.div>
        <Line color={props.theme}
        initial={{
            height: 0
        }
    }
            animate={{
                height:'8rem'
            }}
            transition={{
                type:'spring',duration:1, delay:0.8
            }}
        
        />
    </Icons>
  )
}

export default SocialIcons